export default [
  {
      field: 'hr_previred_apv_id',
      type: 'autocompleteObject',
      vuetifyProps: {
          label: 'APV',
      },
      options: {
          data: [],
          text: 'description',
          value: 'id',
      },
      rules: ['required'],
  },
  {
      field: 'hr_previred_apv_payment_type_id',
      type: 'autocompleteObject',
      vuetifyProps: {
          label: 'Forma de Pago',
      },
      options: {
          data: [],
          text: 'description',
          value: 'id',
      },
      rules: ['required'],
  },
  {
      field: 'contract_number',
      type: 'text',
      vuetifyProps: {
          label: 'N de Contrato',
      },
      rules: ['required'],
      value: '',
  },
  {
      field: 'apv',
      type: 'text',
      format: 'currency',
      vuetifyProps: {
          label: 'APV',
      },
      rules: ['required'],
      value: '',
  },
  {
      field: 'apv_afp',
      type: 'text',
      format: 'currency',
      vuetifyProps: {
          label: 'Cuenta 2 AFP',
      },
      rules: ['required'],
      value: '',
  },
]
